import { lazy, Suspense, useMemo, type ComponentType } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { featureManifests } from '@/app/navigation/manifests'
import { AppShellLayout } from '@/app/shell/AppShellLayout'
import '@/platform/shell/shell.css'
import { SessionGate } from '@/platform/session/SessionGate'
import { AuthCallbackPage } from '@/platform/session/AuthCallbackPage'
import { FeatureLoader } from '@/platform/ui/FeatureLoader'
import { FeatureBoundary } from './FeatureBoundary'

function FeatureRoute({ featureId, load }: { featureId: string; load: () => Promise<{ default: ComponentType }> }) {
  const Entry = useMemo(() => lazy(load), [load])
  return <FeatureBoundary key={featureId}><Suspense fallback={<FeatureLoader />}><Entry /></Suspense></FeatureBoundary>
}

export const router = createBrowserRouter([
  { path: '/auth/callback', element: <AuthCallbackPage /> },
  {
    element: <SessionGate><AppShellLayout /></SessionGate>,
    children: [
      { index: true, element: <Navigate to="/english-knowledge/vocabularies/catalogs" replace /> },
      { path: '/english-knowledge/assessment-framework/*', element: <Navigate to="/english-knowledge/principles" replace /> },
      { path: '/lessons/knowledge/skills/*', element: <Navigate to="/english-knowledge/standards" replace /> },
      { path: '/english-knowledge/child-development/*', element: <Navigate to="/english-knowledge/standards" replace /> },
      { path: '/english-knowledge/skills/*', element: <Navigate to="/english-knowledge/standards" replace /> },
      ...featureManifests.map((feature) => ({
        path: feature.path,
        element: <FeatureRoute key={feature.id} featureId={feature.id} load={feature.load} />,
      })),
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
])
